import { useLang } from '../contexts/LangContext';
import styles from './LangSwitcher.module.css';

export default function LangSwitcher() {
  const { lang, switchLang, languages } = useLang();

  if (!languages || languages.length <= 1) return null;

  return (
    <div className={styles.switcher}>
      {languages.map(l => (
        <button
          key={l.code}
          id={`btn-lang-${l.code}`}
          className={`${styles.btn} ${lang === l.code ? styles.active : ''}`}
          onClick={() => switchLang(l.code)}
        >
          {l.flag} {l.code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
